import { addonsClient } from "../api/ApiClients";
import ServiceBase from "./ServiceBase";

class AddonsService extends ServiceBase {
  async getUserActiveAddons() {
    return addonsClient.getUserAddons();
  }

  async getAddonsCatalog() {
    return addonsClient.getAddonCatalog();
  }
}

export default new AddonsService();
